var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleCi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    fill: "#343434",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.075,
    cy: 46.886,
    rx: 7.051,
    ry: 7.087
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.277 39.372c0 .085-.085.256-.085.34 0 .768.595 1.452 1.444 1.452h11.978c.595 0 1.02-.34 1.274-.854 2.464-5.465 7.9-9.137 14.1-9.137 8.58 0 15.546 7.002 15.546 15.626S91.57 62.427 83 62.427c-6.286 0-11.638-3.757-14.1-9.05-.255-.598-.68-.94-1.274-.94H55.637c-.765 0-1.445.598-1.445 1.452 0 .085 0 .256.085.34 3.313 12.98 14.95 22.543 28.798 22.543 16.395 0 29.732-13.406 29.732-29.886S99.47 17 83.075 17C69.23 17 57.6 26.564 54.277 39.372z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCi);
export default __webpack_public_path__ + "static/media/CircleCI.4718d9a1c4f1a006931c8c97a4f120b3.svg";
export { ForwardRef as ReactComponent };